/**
 * @vuepress
 * ---
 * title: AffectedTransformer
 * ---
 */

import Transformer from '../transformer'

/**
 * @class AffectedTransformer
 * @author Jose Luis R.
 */
class AffectedTransformer extends Transformer {
  static fetch({
    id, name, process_abbreviation: processAbb, process_color: processColor
  }) {
    return {
      id, name, processAbb, processColor
    }
  }
}

export default AffectedTransformer
